import React from 'react';
import ModalButton from './ModalButton';


const ThanksModal = ({closeModal})=>{

	return <div>
		<div>Thanks for your order!  An invoice has been sent.  Once the invoice is paid, your new licence will be activated as soon 
			as possible, but please allow up to two working days.  If you have any concerns, please reach out at info@jumbletree.com
		</div>
		<ModalButton text="Done" onClick={closeModal} />
	</div>
}

export default ThanksModal;